<template>
    <div class="stepSixRoot">
      <div class="circleItem"><CircleVue currentIndex="6"></CircleVue> </div>
      <div class="backPageItem"><BackPageVue  @backPreviewPage="hanldGoBack"></BackPageVue> </div>

        <div>
            <div class="titleLine">Citation Goals</div>
        </div>

        <div class="inputBlock">
          <div class="fieldLine">What is your current number of citations in Google Scholar?</div>
          <div class="inputLine selectLine">
            <!-- <el-input v-model.number="citNum" placeholder=""  type="tel" @input="value=>handleInput(value,1)"  @keydown.native="handleKeyDown"></el-input> -->
            <el-select v-model="citNum" placeholder="">
              <el-option v-for="item in oneSelectArr"  :key="item.value"  :label="item.text" :value="item.value">{{ item.text }}</el-option>
            </el-select>
 
            <!-- <span  class="fieldLine">current</span> -->
          </div>
        </div>
        <div  class="inputBlock">
          <div class="fieldLine">What citation count are you aiming for?</div>
          <div class="inputLine selectLine">
            <!-- <el-input v-model.number="currentNum" placeholder=""   type="tel" @input="value=>handleInput(value,2)"  @keydown.native="handleKeyDown"></el-input> -->
            <el-select v-model="currentNum" placeholder="">
              <el-option v-for="item in twoSelectArr"  :key="item.value"  :label="item.text" :value="item.value">{{ item.text }}</el-option>
            </el-select>
            <!-- <div  class="fieldLine" style="white-space: nowrap;">target</div> -->
          </div>
          <div class="errWarm" v-if="citNum&&currentNum&&(citNum>currentNum)">{{errText}}</div>
        </div>
        <div  class="inputBlock">
          <div class="fieldLine">When would you like to reach this goal?</div>
          <div class="inputLine">
            <el-input v-model.number="monthNum" placeholder=""  type="tel" @input="value=>handleInput(value,3)"  @keydown.native="handleKeyDown"></el-input>
            <div  class="fieldLine" style="white-space: nowrap;">months (e.g., in 21 months)</div>
          </div>
        </div>
      
       
      
        <div class="btnLine">
          <div class="disBtn" v-if="!(citNum&&currentNum&&monthNum&&(citNum<=currentNum))">Quick Analysis</div>
          <div class="chooseBtn" v-else @click="goToNextStep">Quick Analysis</div>
        </div>
        <!-- <div class="LastLine">
            <div class="skipBtn" @click="goToNextStep">Skip</div>
        </div> -->
      <div class="LastLine2">
          <div class="oneItem">©  2012-2026 PaperSpotlight. All rights reserved.</div>
          <!-- <div class="twoItem">The data presented is based on our independent research and analysis. While we strive for accuracy, results may vary across different fields and contexts. Unauthorized reproduction or distribution of this content is prohibited.</div> -->
      </div>
    </div>
</template>
<script>
import CircleVue from './circle.vue'
import BackPageVue from './backPage.vue'
import moment from 'moment';

export default {
    components:{CircleVue,BackPageVue},
    data(){
      return{
        imgObj:{
          guideHomebg1:require("../../assets/img/main/guideHomebg1.png"),
          guideHomebg2:require("../../assets/img/main/guideHomebg2.png"),
        },
        citNum:'',
        currentNum:'',
        monthNum:'',
        errText: 'Aiming citation should be no less than the current citation.',
        oneSelectArr:[
          {value:1,text:'0-40'},
          {value:2,text:'41-100'},
          {value:3,text:'101-300'},
          {value:4,text:'301-800'},
          {value:5,text:'801-2700'},
          {value:6,text:'2701-8000'},
          {value:7,text:'8000+'},
        ],
        twoSelectArr:[
          {value:1,text:'0-40'},
          {value:2,text:'41-100'},
          {value:3,text:'101-300'},
          {value:4,text:'301-800'},
          {value:5,text:'801-2700'},
          {value:6,text:'2701-8000'},
          {value:7,text:'8000+'},
        ]
      }
  },
  mounted: function() {
    let userData = JSON.parse(localStorage.getItem('userData'))
    if(userData&&userData.stepSix&&userData.stepSix.length){
      this.citNum = userData&&userData.stepSix&&userData.stepSix[0] 
      this.currentNum = userData&&userData.stepSix&&userData.stepSix[1]
      this.monthNum = userData&&userData.stepSix&&userData.stepSix[2] 
    }
  },
  methods:{
    hanldGoBack(){
      localStorage.setItem('guideIndex', 5);
      this.$emit('changePage', 5);
    },
     // 处理输入，确保只能是数字
    handleInput(value,item) {
      if(item == 1){
        this.citNum = value.replace(/[^\d]/g, '')
      }else if(item == 2){
        this.currentNum = value.replace(/[^\d]/g, '')
      }else{
        this.monthNum = value.replace(/[^\d]/g, '')
      }
    },
    // 阻止非数字键的默认行为
    handleKeyDown(e) {
      const allowedKeys = [
        8,   // Backspace
        9,   // Tab
        13,  // Enter
        37,  // Left arrow
        38,  // Up arrow
        39,  // Right arrow
        40,  // Down arrow
        46,  // Delete
        48, 49, 50, 51, 52, 53, 54, 55, 56, 57,  // 数字0-9
        96, 97, 98, 99, 100, 101, 102, 103, 104, 105  // 小键盘数字0-9
      ]
      
      if (!allowedKeys.includes(e.keyCode) && 
          !(e.ctrlKey && [65, 67, 86, 88].includes(e.keyCode))) {  // 允许Ctrl+A/C/V/X
        e.preventDefault()
      }
    },
    goToRegister(){
      let userData = JSON.parse(localStorage.getItem('userData'))
      userData.weight = this.getWeight(userData)
      if(this.inputEmali){
        userData.stepSeven = this.inputEmali
        let str = JSON.stringify(userData)
        localStorage.setItem('userData', str);

      }else{
        userData.stepSeven = ''
        let str = JSON.stringify( userData)
        localStorage.setItem('userData', str);
      }

      let param={
        email:this.inputEmali,
        body: JSON.stringify(userData)
      }
      this.$https('potentialEmail',param).then(res => {
              
            }).catch(err=>{
            })

      // this.$emit('changePage', 20);
      // if(this.$route.path !== '/resetPassword'){
      //   this.$router.push('/resetPassword'); // 如果使用了路径
      // }
    },
    goToNextStep(index){
        console.log(this.citNum,this.currentNum)
        localStorage.setItem('guideIndex', 8);

        let userData = JSON.parse(localStorage.getItem('userData'))||{}
        if(this.citNum && this.currentNum && this.monthNum){
          userData.stepSix =[parseInt(this.citNum) ,parseInt(this.currentNum) ,parseInt(this.monthNum)]
          let str = JSON.stringify(userData)
          localStorage.setItem('userData', str);
        }else{
          userData.stepSix = []
          let str = JSON.stringify( userData)
          localStorage.setItem('userData', str);
        }
        this.goToRegister()
        this.$emit('changePage', 8);
      
    },
    getWeight(item){
      let  defaultWeight=[
        [3,2,1,2],
        [1,1,5,1],
        [1,1,4,2],
        [2,2,2,2],
        [3,3,1,1],
        [2,2,2,2],

      ]
      console.log('item1',item)
      let weight = []
      let one = parseInt(item.stepOne)
      if(one>=0){
        one = one-1
        weight = [...defaultWeight[one]]
      }else{
        weight = [2,2,2,2]
      }
      let year = item.stepFive.length ? parseInt(item.stepFive[0]):''
      // 目标年份
      year = parseInt(year) ; 
      // 获取当前年份
      const currentYear = moment().year(); // 或 new Date().getFullYear()
      // 计算差值（绝对值，避免负数）
      const yearsDiff = Math.abs(currentYear - year);
      console.log('weight1',weight,year,yearsDiff)

      if(0<=yearsDiff && yearsDiff<=1){ 
        weight[0] =  weight[0]+1
        weight[1] =  weight[1]-1
        weight[2] =  weight[2]+1
        weight[3] =  weight[3]-1
      }else if(yearsDiff>=3){
        weight[0] =  weight[0]-1
        weight[1] =  weight[1]-1
        weight[2] =  weight[2]+2
      }
      console.log('weight2',weight)

      let currentCitation = item.stepSix.length ?item.stepSix[0]:''
      if(0<currentCitation && currentCitation<=2){
        weight[0] =  weight[0]-1
        weight[1] =  weight[1]-1
        weight[2] =  weight[2]+1
        weight[3] =  weight[3]+1
      }else if(currentCitation>2 &&currentCitation<5){
        console.log(22,currentCitation)

        weight[0] =  weight[0]+1
        weight[1] =  weight[1]+1
        weight[2] =  weight[2]-1
        weight[3] =  weight[3]-1
      }else if(currentCitation>=5){
        console.log(3333,currentCitation)
        weight[0] =  weight[0]+2
        weight[1] =  weight[1]+1
        weight[2] =  weight[2]-1
        weight[3] =  weight[3]-2
      }
      console.log('weight3',weight,currentCitation)

      let muchMOnth = item.stepSix.length ?item.stepSix[2]:''
      if(0<muchMOnth && muchMOnth<7){
        weight[0] =  weight[0]-1
        weight[1] =  weight[1]-2
        weight[2] =  weight[2]+2
        weight[3] =  weight[3]+1
      }else if(muchMOnth>=7 && muchMOnth<=11){
        weight[0] =  weight[0]
        weight[1] =  weight[1]-1
        weight[2] =  weight[2]+1
        weight[3] =  weight[3]
      }
      console.log('weight5',weight,muchMOnth)

        while(Math.min(...weight)<0){
          let minNum = Math.min(...weight)
          let maxNum = Math.max(...weight)
          const minIndex = weight.indexOf(minNum);
          const maxIndex = weight.indexOf(maxNum); // 找到最大值的索引
          weight[minIndex] =  weight[minIndex] +1
          weight[maxIndex] =  weight[maxIndex] -1

        }
      console.log('weight5',weight)

        return weight

    }
  }
}
</script>

<style lang="scss">

.inputLine .el-input__inner {
  width: 110px !important;
  // border: none !important;
  // border-bottom: 1px solid #000 !important;
  // border-radius: 0 !important;
  // padding-left: 0 !important;
  // padding-right: 0 !important;
}
.selectLine .el-input__inner{
  width: 180px !important;
}

.inputLine .el-input__inner:focus {
  border-bottom-color: #feae00 !important;
}
.inputLine .el-input__inner{
  color: var(---2, #333);
    text-align: center;
    font-size: 18px !important;
}
.stepSixRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0 30px 0;
    gap: 50px;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 100px;
      top:40px;
      width: 30px;
      height: 30px;
    }
    .circleItem{
      position: absolute;
      right: 100px;
      top:40px;
      width: 50px;
      height: 50px;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 900px;
        color: var(---2, #333);
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .inputBlock{
      // width: 50%;
      width: 650px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
      position: relative;
    }
    .errWarm{
      position: absolute;
      left: 0;
      right: 0;
      bottom: -26px;
      font-size: 14px;
      height: 26px;
      line-height: 26px;
      color: rgb(221,44,0);
    }
    .fieldLine{
        color: var(---2, #333);
        // text-align: center;

        /* 一级标题 */
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        // text-transform: capitalize;
    }
    .inputLine{
      display: flex;
      gap: 12px;
      align-items: center;
    }
   .cascadeSelect{
        display: flex;
        gap: 20px;
        .el-select{
            width: 320px;
        }
   }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -50px;
      .skipBtn{
          cursor: pointer;
          padding: 12px 40px;
            font-size: 16px;
            color: #999;
        }
      }
    .LastLine2{
      flex: 1 1;
      display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -20px;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
@media screen and (max-width:767px) { 
  .stepSixRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20vw 6vw 10vw 6vw;
    gap: 6vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 2vw;
      top:3vw;
      width: 4vw;
      height: 4vw;
    }
    .circleItem{
      position: absolute;
      right: 2vw;
      top:3vw;
      width: 8vw;
      height: 8vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 6vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 2vw;
        max-width: 900px;
        color: var(---2, #333);
        text-align: center;
        font-size: 3.4;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .inputBlock{
      // width: 50%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
    .errWarm{
      bottom: -3.2vw;
      font-size: 2.6vw;
      height: 3vw;
      line-height: 3vw;
    }
    .fieldLine{
        color: var(---2, #333);
        text-align: start;

        /* 一级标题 */
        font-size: 4vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        // text-transform: capitalize;
    }
    .inputLine{
      display: flex;
      gap: 2vw;
      align-items: center;
    }
   .cascadeSelect{
        display: flex;
        gap: 20px;
        .el-select{
            width: 320px;
        }
   }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -6vw;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 3.4vw;
            color: #999;
        }
      }
      .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -4vw;
        .oneItem{
            color: var(---1, #000);
            text-align: center;
            font-size: 3.4vw;
            font-style: normal;
            font-weight: 400;
            line-height: 1.3; /* 110% */
          }
          .twoItem{
            width: 90%;
            max-width: 900px;
            color: #aaa;
            text-align: center;
            font-size: 3vw;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
    }
}
}


@media screen  and (min-width: 767px) and (max-width: 1200px){
  .stepSixRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6vw 0 3vw 0;
  gap: 5vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .circleItem{
      position: absolute;
      right: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 3.2vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 900px;
        color: var(---2, #333);
        text-align: center;
        font-size: 1.6vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .inputBlock{
      // width: 50%;
      width: 65vw;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1.2vw;
    }
     .errWarm{
      bottom: -2vw;
      font-size: 1.4vw;
      height: 2vw;
      line-height: 2vw;
    }
    .fieldLine{
        color: var(---2, #333);
        // text-align: center;

        /* 一级标题 */
        font-size: 2.4vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        // text-transform: capitalize;
    }
    .inputLine{
      display: flex;
      gap: 1.2vw;
      align-items: center;
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -5vw;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 1.6vw; 
            color: #999;
        }
      }
      .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -1vw;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 1.6vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.3; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;

          text-align: center;
          font-size: 1.2vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
}
</style>


